import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarCheck } from "@phosphor-icons/react";
import { openBooking } from "@/lib/anim";

export const StickyBookCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 24 }}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.96 }}
          onClick={openBooking}
          className="fixed bottom-6 left-6 z-40 inline-flex items-center gap-2 font-semibold text-black bg-gradient-to-r from-teal to-cobalt rounded-full pl-5 pr-6 py-3.5 shadow-[0_12px_40px_-8px_rgba(64,224,208,0.6)] hover:shadow-[0_16px_50px_-8px_rgba(59,110,255,0.7)] transition-shadow duration-300"
          data-testid="sticky-book-call"
          aria-label="Book a call"
        >
          <CalendarCheck size={20} weight="fill" />
          Book a call
        </motion.button>
      )}
    </AnimatePresence>
  );
};
